export default __webpack_public_path__ + "static/media/Battlefield.41801f29.jpg";